import $ from 'jquery';

export default function bind() {}

export function showError() {
  $('#sse-error-modal')
    .modal({
      closable: false,
    })
    .modal('show');
}



// WEBPACK FOOTER //
// ./src/plugins/sse.js